var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getOlaState.olaStateStr)?_c('div',{staticClass:"ola"},[_c('div',{staticClass:"icon",class:{ success: _vm.getOlaState.olaSuccess }},[_c('van-icon',{attrs:{"name":"phone-o"}})],1),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.getOlaState.olaStateStr))]),_c('div',{staticClass:"cancel",on:{"click":_vm.onHangup}},[_vm._v("挂断")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }